import * as React from 'react';
import { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '../utils/propStyles';

const StyledVisuallyHiddenDiv = styled<any, any>('div')`
    ${propStyles};
`;

StyledVisuallyHiddenDiv.defaultProps = {
    position: 'absolute',
    left: '-10000px',
    top: 'auto',
    width: '1px',
    height: '1px',
    overflow: 'hidden',
};

class VisuallyHiddenWrapper extends Component<any, any> {
    render() {
        const { children, theme, as } = this.props;
        return (
            <StyledVisuallyHiddenDiv as={as} {...theme.VisuallyHidden}>
                {children}
            </StyledVisuallyHiddenDiv>
        );
    }
}

export default withTheme(VisuallyHiddenWrapper);



// WEBPACK FOOTER //
// ./src/Components/VisuallyHiddenWrapper.tsx